// ============================================================
// VCS.DatingUi — Startseite, Screen und View-Wechsel im Dating-Teil
// ============================================================
// Pendant zu dating_home_screen.dart + dating_back_button.dart.
//
// Zwei Ebenen, mit Absicht getrennt:
//
//   Startseite = #tabDating, ein Tab in #appShell wie Chats oder Kontakte.
//                Die Bottom-Nav bleibt sichtbar. Dating findet nur, wer es
//                sieht -- als Eintrag im "+"-Menue sah es niemand.
//   Unterseiten = .dating-view in #datingScreen, Vollbild ohne Nav. Beim
//                Wischen und im Radar waere eine Navigationsleiste im Weg.
//
// Deshalb ist 'home' KEIN Eintrag in VIEWS: Die Startseite ist ein Tab, kein
// View. Der Weg dorthin fuehrt ueber _showHome() und damit ueber die Nav.
//
// Der Zurueck-Pfeil fuehrt IMMER zur Dating-Startseite, nie dorthin zurueck,
// wo man hergekommen ist: Ein Knopf, der mal hier- und mal dorthin fuehrt, ist
// keiner, auf den man sich verlaesst. (Begruendung siehe dating_back_button.dart.)
// ============================================================
window.VCS = window.VCS || {};

VCS.DatingUi = class {

    // ── Konstanten ───────────────────────────────────────────
    // Nur die Vollbild-Ansichten. Die Namen sind die Wahrheit: showView() nimmt
    // nichts an, was hier nicht steht, und faellt sonst auf die Startseite zurueck.

    static VIEWS = ['profile', 'deck', 'radar', 'matches'];

    static TAB_ID = 'tabDating';

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        this._view = {
            tab        : $('#tabDating'),
            screen     : $('#datingScreen'),
            views      : $('#datingScreen .dating-view'),
            matchesBody: $('#datingMatchesBody')
        };
        // 'home' heisst: Startseiten-Tab sichtbar, #datingScreen zu.
        this._current = 'home';

        this._matches = [];
        // photoHash -> Blob-URL. Auch hier brauchen die Fotos den Auth-Header.
        this._matchUrls = new Map();
    }

    // ── Dating betreten / verlassen ──────────────────────────

    // Einstieg von aussen (Bottom-Nav verdrahtet sich ueber data-tab selbst,
    // das hier ist der Weg fuer Aufrufer wie das "+"-Menue).
    open() {
        this._showHome();
        console.log('[dating] Startseite geoeffnet');
    }

    // Die Zahl auf der „Mögen dich"-Kachel. Ab 1 sichtbar, sonst versteckt — eine „0" waere
    // eine Enttaeuschung, kein Anreiz. Fehler schluckt getLikesCount (dann bleibt sie weg).
    async _loadLikesBadge() {
        const badge = document.getElementById('datingLikesBadge');
        if (!badge) {
            return;
        }
        const n = await VCS.datingCore.getLikesCount();
        if (n > 0) {
            badge.textContent = String(n);
            badge.classList.remove('hidden');
        } else {
            badge.classList.add('hidden');
        }
    }

    close() {
        console.log('[dating] Dating verlassen');
        this._notifyHide(this._current);
        this._current = 'home';
        VCS.nav?.showAppShell?.('tabChats');
    }

    // Offen ist Dating auch dann, wenn nur der Startseiten-Tab sichtbar ist --
    // nicht nur im Vollbild-Screen.
    isOpen() {
        return !this._view.screen.hasClass('hidden')
            || VCS.state?.activeTabId === VCS.DatingUi.TAB_ID;
    }

    currentView() {
        return this._current;
    }

    // Geladene Matches (fuer das Finde-mich-Spiel, um den Namen zum Handle zu zeigen).
    matches() {
        return this._matches || [];
    }

    // ── View-Wechsel ─────────────────────────────────────────

    // Zurueck auf die Startseite: #datingScreen zu, Tab wieder her. Ueber
    // showAppShell(), weil showScreen() alleine den Screen stehen liesse.
    _showHome() {
        if (this._current !== 'home') {
            this._notifyHide(this._current);
        }
        this._view.views.addClass('hidden');
        this._current = 'home';
        if (this._isDesktop()) {
            // Desktop-Zwei-Spalten: Menue links stehen lassen, rechte Pane zeigt
            // den Platzhalter statt des Chat-Leerzustands.
            $('#datingViewHome').removeClass('hidden');
            VCS.nav?.showDatingScreen?.();
        } else {
            VCS.nav?.showAppShell?.(VCS.DatingUi.TAB_ID);
        }
        // Frisch bei jeder Rueckkehr zur Startseite — kommt man aus „Mögen dich", hat sich
        // die Zahl gerade geaendert (geliked oder weggeklickt).
        this._loadLikesBadge();
        this._syncActiveTile('home');
    }

    async showView(name) {
        // Erneuter Klick auf die schon offene Profil-Kachel: NICHT neu laden. onShow
        // wuerde das Formular frisch vom Server ziehen und getippte Eingaben verwerfen.
        if (name === 'profile' && this._current === 'profile') {
            return;
        }

        // Verlaesst man die Profil-View mit ungespeicherten Aenderungen, erst fragen.
        // Deckt Menue-Kacheln und (ueber handleBack) den Zurueck-Weg ab. Nur bei
        // explizitem false (Nutzer will bleiben) abbrechen -- fehlt das Modul, soll
        // die Navigation nicht haengen.
        if (this._current === 'profile' && name !== 'profile'
                && (await VCS.datingProfile?.confirmLeave?.()) === false) {
            return;
        }

        if (name === 'home') {
            this._showHome();
            return;
        }

        // „Mögen dich" ist keine eigene View: Es ist die Deck-View in einem anderen Modus
        // (Query /dating/likes, eigener Titel). Deshalb hat es kein eigenes Markup — es zeigt
        // #datingViewDeck und reicht das Flag an onShow durch. `_current` bleibt 'deck', damit
        // _notifyHide und handleBack unveraendert funktionieren.
        const likesMode = name === 'likes';
        const view = likesMode ? 'deck' : name;

        if (VCS.DatingUi.VIEWS.indexOf(view) === -1) {
            console.warn('[dating] showView: unbekannte View "' + name + '" -> home');
            this._showHome();
            return;
        }

        // Die verlassene View zuerst benachrichtigen: Dort haengen Blob-URLs
        // (Dating-Fotos brauchen Auth, kommen also per fetch statt per <img src>)
        // und ggf. eine rAF-Schleife (Radar). Beides muss weg, bevor die naechste
        // View aufmacht -- sonst waechst der Speicher mit jedem Besuch.
        if (this._current !== view) {
            this._notifyHide(this._current);
        }

        // Vom Tab kommend liegt #datingScreen noch versteckt hinter #appShell.
        // Auf Desktop bleibt dabei das Menue links stehen (rechte Pane), auf Mobile
        // ist es ein Vollbild-Screen.
        VCS.nav?.showDatingScreen?.();

        this._view.views.addClass('hidden');
        const id = 'datingView' + view.charAt(0).toUpperCase() + view.slice(1);
        $('#' + id).removeClass('hidden');
        this._current = view;
        // Im Desktop-Menue die gewaehlte Funktion markieren (name, nicht view: bei
        // „Mögen dich" ist name='likes', view='deck').
        this._syncActiveTile(name);

        // View-spezifische Aktionen — analog zu den Tab-Aktionen in switchTab().
        // Doppeltes Optional-Chaining, weil die Module der spaeteren Phasen noch
        // nicht existieren: Die Startseite muss auch dann erreichbar bleiben.
        if (view === 'profile') { VCS.datingProfile?.onShow?.(); }
        if (view === 'deck')    { VCS.datingDeck?.onShow?.(likesMode); }
        if (view === 'radar')   { VCS.datingRadar?.onShow?.(); }
        if (view === 'matches') { this.loadMatches(); }
    }

    _notifyHide(name) {
        if (name === 'profile') { VCS.datingProfile?.onHide?.(); }
        if (name === 'deck')    { VCS.datingDeck?.onHide?.(); }
        if (name === 'radar')   { VCS.datingRadar?.onHide?.(); }
        if (name === 'matches') { this._releaseMatchUrls(); }
    }

    // Sprachwechsel: neu zeichnen, aber nur wenn die Liste gerade offen ist.
    // Die Daten stehen in this._matches und ueberleben das Rendern.
    onLangChange() {
        if (this._current === 'matches' && this.isOpen()) {
            this._renderMatches();
        }
    }

    // Zurueck: Vollbild-View -> Startseiten-Tab. Weiter zurueck muss der Pfeil
    // nicht fuehren -- auf der Startseite steht die Bottom-Nav, und die ist der
    // Weg hinaus. Wird sowohl vom sichtbaren Pfeil als auch vom Hardware-/
    // Browser-Zurueck aufgerufen (navigation.js _handleBackNavigation); beide
    // greifen nur, solange #datingScreen offen ist.
    handleBack() {
        // Der Match-Dialog liegt ueber der View und muss zuerst weg — sonst
        // wechselt Zurueck die Ansicht darunter, waehrend er offen stehen bleibt.
        if (VCS.datingDeck?.closeMatchOverlay?.()) {
            return;
        }
        // Danach das Profil-Overlay: Es liegt ueber dem Stapel, aber unter dem
        // Match-Dialog (wer aus dem Profil heraus liked, bekommt den Match darueber).
        // Die Reihenfolge hier ist die Stapelreihenfolge auf dem Bildschirm.
        if (VCS.datingDeck?.closeCandidateOverlay?.()) {
            return;
        }
        // Wer ueber das Radar in den Stapel gegangen ist, kommt auch dorthin
        // zurueck — erst von dort geht es zur Startseite. Sonst ueberspraenge
        // Zurueck genau die Ansicht, aus der man kam.
        const backToRadar = this._current === 'deck' && VCS.datingDeck?.cameFromRadar?.();
        this.showView(backToRadar ? 'radar' : 'home');
    }

    // Der Nav-Knopf ruft switchTab() direkt ueber data-tab, nicht open(). Damit
    // der interne Zustand dabei nicht stehen bleibt, meldet navigation.js den
    // Tab-Wechsel hierher zurueck: Sonst haelt eine verlassene View ihre
    // Blob-URLs fest und _current zeigt auf etwas Unsichtbares.
    onTabShow() {
        if (this._current !== 'home') {
            this._notifyHide(this._current);
            this._view.views.addClass('hidden');
            this._current = 'home';
        }
        // Desktop: rechte Pane als Platzhalter zeigen (switchTab hat evtl. den
        // Chat-Leerzustand eingeblendet). Mobile: nur der Tab, #datingScreen bleibt zu.
        if (this._isDesktop()) {
            this._view.views.addClass('hidden');
            $('#datingViewHome').removeClass('hidden');
            VCS.nav?.showDatingScreen?.();
        }
        // Immer, auch wenn schon 'home': Der Tab kann betreten werden, waehrend jemand neu
        // geliked hat — die Kachel-Zahl soll dann stimmen.
        this._loadLikesBadge();
        this._syncActiveTile('home');
    }

    // Beim Wechsel auf einen anderen Tab schliesst navigation.js die Desktop-Pane
    // (#datingScreen) und ruft dies auf: offene View benachrichtigen, damit ihre
    // Blob-URLs/rAF-Schleifen freigegeben werden, sonst waechst der Speicher.
    onLeave() {
        if (this._current !== 'home') {
            this._notifyHide(this._current);
            this._view.views.addClass('hidden');
            this._current = 'home';
        }
        this._syncActiveTile('home');
    }

    // ── Desktop-Helfer ───────────────────────────────────────

    _isDesktop() {
        return VCS.nav?.isDesktopLayout?.() === true;
    }

    // true, wenn gerade die Profil-View offen ist UND ungespeicherte Aenderungen
    // vorliegen. navigation.js fragt danach, bevor ein Tab-Wechsel den Screen
    // wegschaltet, und der beforeunload-Handler (init) fuer Reload/Schliessen.
    isProfileDirty() {
        return this._current === 'profile' && VCS.datingProfile?.isDirty?.() === true;
    }

    // Markiert im Desktop-Menue die Kachel der offenen Funktion. Auf Mobile gibt es
    // kein stehendes Menue, die Markierung ist dort unsichtbar (schadet aber nicht).
    _syncActiveTile(view) {
        this._view.tab.find('[data-dating-view]').each(function() {
            $(this).toggleClass('dating-tile--active',
                String($(this).attr('data-dating-view')) === view);
        });
    }

    // ── Matches ──────────────────────────────────────────────
    // Eine Liste zum Anschauen. Chat und Call per Handle gibt es in beiden
    // Clients noch nicht — bis dahin endet der Weg hier.
    //
    // Wird bei jedem Betreten der View neu geladen. Das ersetzt das
    // Herunterziehen zum Aktualisieren aus der App: Die PWA kennt die Geste
    // nirgends, und ein Wechsel auf die Liste ist ohnehin der Moment, in dem man
    // wissen will, wer neu dazugekommen ist.

    async loadMatches() {
        this._view.matchesBody.html('<div class="dating-loading"><div class="dating-spinner"></div></div>');
        this._releaseMatchUrls();

        const matches = await VCS.datingCore.getMatches();
        this._matches = matches;

        // Parallel statt nacheinander — bei einer langen Liste waere das sonst
        // eine Kette von Rundreisen.
        await Promise.all(matches.map(async (m) => {
            const hash = m.photos && m.photos[0];
            if (!hash || this._matchUrls.has(hash)) {
                return;
            }
            this._matchUrls.set(hash, '');
            this._matchUrls.set(hash, await VCS.datingCore.loadPhotoUrl(hash));
        }));

        console.log('[dating] Matches geladen: anzahl=' + matches.length);
        this._renderMatches();
    }

    _renderMatches() {
        if (!this._matches.length) {
            this._view.matchesBody.html(
                '<div class="dating-state">'
                + '<div class="dating-state-icon">'
                + '<svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" stroke-width="1.5" fill="none">'
                + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>'
                + '</svg></div>'
                + '<h3 class="dating-state-title">' + escapeHtml(t('datingNoMatches')) + '</h3>'
                + '<p class="dating-state-body">' + escapeHtml(t('datingNoMatchesHint')) + '</p>'
                + '</div>'
            );
            return;
        }

        const rows = this._matches.map((m) => {
            const hash = m.photos && m.photos[0];
            const url  = hash ? (this._matchUrls.get(hash) || '') : '';
            const age  = m.birthYear > 0 ? (new Date().getUTCFullYear() - m.birthYear) : 0;
            const name = age > 0 ? (m.displayName + ', ' + age) : (m.displayName || '');
            const country = m.country ? (VCS.DatingCore.COUNTRIES[m.country] || m.country) : '';
            const sub  = country ? (country + ' · ' + (m.bio || '')) : (m.bio || '');
            // Sternzeichen als eigene Zeile zwischen Name und Land/Bio -- wie auf der
            // Swipe-Karte. Nur wenn Monat/Tag gesetzt sind (sonst gibt zodiac() null).
            const mZodiac = VCS.DatingCore.zodiac(m.birthMonth, m.birthDay);
            const zodiacHtml = mZodiac
                ? '<div class="dating-matches-sub dating-matches-zodiac">'
                    + escapeHtml(mZodiac.emoji + ' ' + t('datingZodiac_' + mZodiac.key)) + '</div>'
                : '';

            // Kein <img src=""> bei fehlendem Bild: Ein leeres src laesst den
            // Browser die Seite selbst als Bild anfordern.
            const avatar = url
                ? '<img src="' + escapeHtml(url) + '" alt="">'
                : '<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="1.8" fill="none">'
                    + '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>'
                    + '<circle cx="12" cy="7" r="4"></circle></svg>';

            // Phase 5: Tap auf die Zeile öffnet das Vollbild-Profil (wie im Stapel); dort
            // stehen [Chat]/[Video] mit Rückfrage. data-handle adressiert den Peer nur über
            // den @handle — nie über eine Nummer (Regel 5).
            // Fremdtexte — escapeHtml ist hier Pflicht.
            return '<div class="dating-matches-row" data-dating-match-open data-handle="' + escapeHtml(m.handle || '') + '" role="button" tabindex="0">'
                + '<div class="dating-matches-avatar">' + avatar + '</div>'
                + '<div class="dating-matches-text">'
                + '<div class="dating-matches-name">' + escapeHtml(name) + '</div>'
                + zodiacHtml
                + '<div class="dating-matches-sub">' + escapeHtml(sub) + '</div>'
                + '</div>'
                // Drei-Punkte-Menue direkt in der Zeile (wie Flutters trailing more_vert):
                // Melden/Blockieren, ohne erst das Profil zu oeffnen.
                + '<button type="button" class="dating-matches-safety" data-dating-match-safety'
                + ' data-handle="' + escapeHtml(m.handle || '') + '"'
                + ' aria-label="' + escapeHtml(t('datingSafetyMenu')) + '">'
                + '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">'
                + '<circle cx="12" cy="5" r="2"></circle><circle cx="12" cy="12" r="2"></circle>'
                + '<circle cx="12" cy="19" r="2"></circle></svg></button>'
                + '</div>';
        });

        this._view.matchesBody.html(rows.join(''));
    }

    _releaseMatchUrls() {
        for (const url of this._matchUrls.values()) {
            VCS.datingCore?.releasePhotoUrl?.(url);
        }
        this._matchUrls.clear();
        this._matches = [];
    }

    // ── Phase 5: vom Match ins Gespraech ─────────────────────
    _matchByHandle(handle) {
        return (this._matches || []).find(x => x.handle === handle);
    }

    // Tap auf einen Match → Vollbild-Profil (mit [Chat]/[Video], jeweils mit Rückfrage). Das
    // Deck-Modul rendert dasselbe Overlay wie im Stapel; die Foto-URLs kommen aus dem Cache
    // dieser Liste. Der Peer wird nur über @handle adressiert (Regel 5).
    async _openMatchProfile(m) {
        if (!m) return;
        // Die Liste lud nur das ERSTE Foto (fürs Avatar). Fürs Profil ALLE Fotos laden,
        // sonst sieht man nur ein Bild und keine Punkte zum Durchblättern (wie im Stapel).
        await Promise.all((m.photos || []).map(async (hash) => {
            if (!hash || this._matchUrls.has(hash)) return;
            this._matchUrls.set(hash, '');   // Platzhalter gegen paralleles Doppelladen
            this._matchUrls.set(hash, await VCS.datingCore.loadPhotoUrl(hash));
        }));
        VCS.datingDeck?.showMatchProfile?.(m, this._matchUrls);
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        // Delegiert an #datingScreen: Views, die spaeter per innerHTML entstehen
        // (Deck-Karten, Match-Liste), bekommen den Zurueck-Pfeil ohne erneutes
        // Verdrahten mit. Zurueck gibt es nur im Vollbild -- der Startseiten-Tab
        // hat keinen Pfeil, dort ist die Bottom-Nav der Weg.
        this._view.screen.on('click', '[data-dating-back]', () => {
            this.handleBack();
        });

        // [data-dating-view] steht an zwei Orten: als Kachel auf der Startseite
        // (#tabDating) und als Abkuerzung im Deck-Kopf (#datingScreen). Beide
        // Container brauchen den Delegaten, sonst waere die Haelfte der Knoepfe
        // stumm.
        this._view.tab.add(this._view.screen).on('click', '[data-dating-view]', (e) => {
            const target = $(e.currentTarget).data('dating-view');
            if (target) {
                this.showView(String(target));
            }
        });

        // Phase 5: Tap auf eine Match-Zeile öffnet das Profil. handle aus data-handle (attr
        // statt .data(), damit ein rein-numerischer base64url-handle nicht zur Zahl wird).
        this._view.screen.on('click', '[data-dating-match-open]', (e) => {
            // Klick auf das Drei-Punkte-Menue oeffnet NICHT das Profil -- es hat seinen
            // eigenen Handler (darunter). Sonst laege beides uebereinander.
            if ($(e.target).closest('[data-dating-match-safety]').length) { return; }
            const handle = String($(e.currentTarget).attr('data-handle') || '');
            this._openMatchProfile(this._matchByHandle(handle));
        });

        // Drei-Punkte-Menue pro Match-Zeile: Melden/Blockieren ueber dasselbe Sheet wie im
        // Profil (VCS.datingDeck.showSafetyMenu). Nach Erfolg raus aus der Liste -- der Server
        // filtert den Geblockten ohnehin, das hier wartet nur nicht aufs Neuladen.
        this._view.screen.on('click', '[data-dating-match-safety]', (e) => {
            e.stopPropagation();
            const handle = String($(e.currentTarget).attr('data-handle') || '');
            const m = this._matchByHandle(handle);
            if (!m) { return; }
            VCS.datingDeck?.showSafetyMenu?.(handle, m.displayName || '', () => {
                this._matches = (this._matches || []).filter((x) => x.handle !== handle);
                this._renderMatches();
            }, true);
        });

        // Reload/Tab-schliessen/Seite verlassen mit ungespeicherten Profil-Aenderungen:
        // native Browser-Warnung. Nur wenn wirklich etwas offen ist -- sonst nervt es
        // bei jedem Neuladen. Der In-App-Weg (Menue, Zurueck, Tab) wird ueber
        // confirmLeave() abgefangen.
        window.addEventListener('beforeunload', (e) => {
            if (this.isProfileDirty()) {
                e.preventDefault();
                e.returnValue = '';
            }
        });
    }
};
